<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOREGLANEGOCIO.LBL_REGLANEGOCIO' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="FormularioReglasNegocio" name="nomFormularioReglasNegocio">
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <br>
            <p-checkbox label="{{  'PRODUCTOREGLANEGOCIO.LBL_RECOGERCREDITOS' | translate}}" binary="true"
                        id="indicadorCredito"
                        name="nomIndicador"
                        formControlName="indicadorRecogerCreditos"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREGLANEGOCIO.LBL_PRODUCTO' | translate }}</label>
            <p-dropdown disableTab  *ngIf="!editar" id="idPlantilla" name="nomPlantilla" [options]="listaSeleccion"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idProductoRegla"
                        (onChange)="AsignarNombre($event.value)"
            ></p-dropdown>
                      <label *ngIf="editar"  class="falso-combo-texto">{{productoReglaNegocio.nombreProductoRegla}}</label>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idProductoRegla.invalid">
              {{ 'PRODUCTOREGLANEGOCIO.MSG_MESESCANCELACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <br>
            <p-checkbox label="{{  'PRODUCTOREGLANEGOCIO.LBL_PRIMERCRETIDO' | translate}}" binary="true"
                        id="indicador"
                        name="nomIndicadorP"
                        formControlName="indicadorPrimerCredito"
            ></p-checkbox>

          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <br>
            <p-checkbox label="{{  'PRODUCTOREGLANEGOCIO.LBL_PORPORCENTAJE' | translate}}" binary="true"
                        id="indicadorPorc"
                        name="nomIndicadorPorc"
                        formControlName="indicadorPorcentajeCancelacion"
                        (onChange)="cambiarInput($event)"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4" *ngIf="!campoMeses">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREGLANEGOCIO.LBL_MESESCANCELACION' | translate }}</label>
            <input type="text" pInputText id="mesesMaximoCanc"
                   name="mesesMaximoCanc"
                   autocomplete="off"
                   formControlName="mesesMaximoCancelacion" numero-entero-reactive
                   [maxlength]="3"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.mesesMaximoCancelacion.invalid">
              {{ 'PRODUCTOREGLANEGOCIO.MSG_MESESCANCELACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4" *ngIf="campoMeses">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREGLANEGOCIO.LBL_PORCENTAJE' | translate }}</label>
            <input type="text" pInputText id="porcentajeCanc"
                   name="porcentajeCanc"
                   autocomplete="off"
                   formControlName="porcentajeCancelacion"  porcentaje-reactive [decimales]="2"
                   [maxlength]="6"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.porcentajeCancelacion.invalid">
              {{ 'PRODUCTOREGLANEGOCIO.MSG_PORCENTAJE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <br>
            <p-checkbox label="{{  'PRODUCTOREGLANEGOCIO.LBL_HABILITADO' | translate}}" binary="true"
                        id="indicadorHab"
                        name="nomIndicadorHab"
                        formControlName="indicadorHabilitado"></p-checkbox>
          </div>
        </div>
      </div>


      <div class="grid form-footer-buttons">
        <div class="form-group col-12" >
          <div *ngIf="!guardando">
            <button  icon="fa fa-plus" label="  {{ editar ? ('BTN_ACTUALIZAR' | translate) : ('BTN_AGREGAR' | translate)}}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>

        </div>

      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="proControles.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" #proControles
                 [value]="listaProductosReglaNegocio" selectionMode="single" dataKey="idProductoAutorizacion"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreProductoRegla}}</td>
              <td class="text-center"> <p-checkbox [(ngModel)]="row.indicadorRecogerCreditos" binary="true" disabled="true"></p-checkbox></td>
              <td class="text-center"> <p-checkbox [(ngModel)]="row.indicadorPrimerCredito" binary="true" disabled="true"></p-checkbox></td>
              <td class="text-center">{{row.mesesMaximoCancelacion}}</td>
              <td class="text-center">{{row.porcentajeCancelacion}}</td>
              <td class="text-center"> <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox></td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="update(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="controles">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
